<script lang="ts" setup>

</script>

<template>
  <div class="sx-popup">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.sx-popup {
  padding: 20px;
  border-radius: 18px;
  box-shadow: 0 4px 21.4px 0 #0000001A;
}
</style>
